import { inject, InjectionToken } from '@angular/core';
import { AppService } from '@services/core-services/app.service';

export const BASE_URL = new InjectionToken('BASE_URL', {
  factory: () => {
    const appService = inject(AppService);
    return appService.getTenantBaseUrl();
  },
  providedIn: 'root',
});
